var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"organization-list-item",class:{ 'is-active': _vm.props.active }},[_c('el-button',{on:{"click":_vm.listeners.click}},[_c('div',{staticClass:"content"},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.props.name))])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }